import { createSelector } from 'reselect';
import { VmafError } from '../../api/ErrorNormalizer';
import { Selector } from '../rootReducer';
import { getVideoText } from '../videoText/selectors';
import { IVideoMeta, IVideoOutput, IVideoOutputState } from './reducer';
import { VideoOutputStatus } from './types';

const getVideoOutputState: Selector<IVideoOutputState> = (state) =>
  state.videoOutput;

const getVideoOutput: Selector<IVideoOutput> = createSelector(
  getVideoOutputState,
  (videoOutputState) => videoOutputState.output,
);
const getVideoOutputDownloadUrl: Selector<string> = createSelector(
  getVideoOutput,
  (videoOutput) => videoOutput.downloadUrl,
);
const getVideoOutputThumbnailUrl: Selector<string> = createSelector(
  getVideoOutput,
  (videoOutput) => videoOutput.thumbnailUrl,
);
const getVideoOutputResultUrl: Selector<string> = createSelector(
  getVideoOutput,
  (videoOutput) => videoOutput.videoUrl,
);
const getVideoOutputTitle: Selector<string> = createSelector(
  getVideoText,
  (videoText) =>
    videoText.openingText || videoText.mainMessage || videoText.closingText,
);
const getVideoOutputStatus: Selector<VideoOutputStatus> = createSelector(
  getVideoOutputState,
  (videoOutputState) => videoOutputState.status,
);
const getVideoOutputError: Selector<VmafError> = createSelector(
  getVideoOutputState,
  (videoOutputState) => videoOutputState.error,
);
const isVideoOutputFailed: Selector<boolean> = createSelector(
  getVideoOutputStatus,
  (status) => status === VideoOutputStatus.VIDEO_ERROR,
);
const isVideoOutputReady: Selector<boolean> = createSelector(
  getVideoOutputStatus,
  (status) => status === VideoOutputStatus.VIDEO_READY,
);
const isVideoOutputInProcess: Selector<boolean> = createSelector(
  getVideoOutputStatus,
  (status) => status === VideoOutputStatus.VIDEO_REQUEST,
);
const isVideoOutputNeedRetry: Selector<boolean> = createSelector(
  getVideoOutputState,
  (videoOutput) => videoOutput.needRetry,
);

const getVideoMeta: Selector<IVideoMeta> = createSelector(
  getVideoOutputState,
  (videoOutputState) => videoOutputState.meta,
);
const getResultVideoId: Selector<string> = createSelector(
  getVideoMeta,
  (meta) => meta.resultVideoId,
);
const getVideoSessionId: Selector<number> = createSelector(
  getVideoMeta,
  (meta) => meta.videoSessionId,
);
const getVideoOutputStartTime: Selector<number> = createSelector(
  getVideoMeta,
  (meta) => meta.startTime,
);
const hasVideoSessionId: Selector<boolean> = createSelector(
  getVideoSessionId,
  (videoSessionId) => !!videoSessionId,
);

export {
  getResultVideoId,
  getVideoSessionId,
  hasVideoSessionId,
  getVideoOutputStartTime,
  getVideoOutputDownloadUrl,
  getVideoOutputThumbnailUrl,
  getVideoOutputResultUrl,
  getVideoOutputTitle,
  getVideoOutputStatus,
  getVideoOutputError,
  isVideoOutputFailed,
  isVideoOutputReady,
  isVideoOutputInProcess,
  isVideoOutputNeedRetry,
};
